import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

export class About extends Component {
  static displayName = About.name;

  render() {
    return (
      <div style={{ marginBottom: '60px' }}>
        <Helmet>
          <title>Über ho.li design – Unsere Geschichte | ho.li design</title>
          <meta name="description" content="Laura & Andi, die Gründer von ho.li design, erzählen die Geschichte hinter ihren Poufs. Handgefertigte Sitzsäcke aus Leidenschaft für schönes Wohnen." />
          <meta name="keywords" content="ho.li design, über uns, Gründer Laura Andi, Sitzsack, Pouf, Geschichte" />
          <meta name="language" content="de" />
          <link rel="canonical" href="https://holidesign.de/about" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Über ho.li design – Unsere Geschichte | ho.li design" />
          <meta property="og:description" content="Laura & Andi, die Gründer von ho.li design, erzählen die Geschichte hinter ihren Poufs. Handgefertigte Sitzsäcke aus Leidenschaft für schönes Wohnen." />
          <meta property="og:url" content="https://holidesign.de/about" />
          <meta property="og:image" content="https://saholiprod2.blob.core.windows.net/sc-holi-prod2/inscene.jpeg" />
          <meta property="og:site_name" content="ho.li design" />
          <meta property="og:locale" content="de_DE" />
        </Helmet>
        <h1 style={{ marginBottom: '40px' }}>Über uns</h1>
        <p>Herzlich willkommen bei ho.li design! Wir sind Laura und Andi. Für uns ist eine Wohnung oder ein Haus nicht nur ein Ort zum Zurückziehen und Wohlfühlen, sondern auch ein Platz, um mit Freunden und Familie Gemeinschaft zu genießen. Um unsere Leidenschaft für Wohnen und Einrichten vom Hobby zum Beruf zu machen, haben wir die ho.li design GmbH gegründet. <br/>
          <br/>
          Unser erstes Produkt, der ho.li Pouf, ist ein mit Styroporkügelchen (EPS-Perlen) gefüllter Sitzsack, der sowohl innen als auch außen verwendet werden kann. Er ist in verschiedenen Farben und Größen erhältlich. Wir arbeiten bereits auf Hochtouren an weiteren Produkten und hoffen, dass ihr viel Freude mit unseren Poufs habt. Solltet ihr Fragen zu uns oder unsreren Produkten haben, kontaktiert uns gerne.</p>
      </div>
    );
  }
}
